const isServer = typeof window === 'undefined';

module.exports = {
  development: {
    API_PATH: 'http://localhost:12345/api/',
    SOLARIS_API_PATH: '',
    SOLARIS_API_PUBLIC_PATH: '',
    DISCOVER_API_PATH: '',
    DISCOVER_API_KEY: '',
    WS_URL: 'wss://localhost/',
    IMG_PATH: 'https://d18gkrbst41gma.cloudfront.net',
    CDN_PATH: 'https://dw5al54dyefdn.cloudfront.net',
    ASSET_PREFIX_PATH: '',
    environment: 'development',
    gaTrackingId: '',
    gaTrackingDomain: '',
    allowBranchTesting: true,
  },
  'development-staging-nice': {
    isNice: true, // Will disable various features, e.g. DFP, cookie banner, blocking signup modal
    USE_DEV_PROXY: true,
    API_PATH: isServer ? 'https://hu-staging.be/api/' : '/api/',
    SOLARIS_API_PATH: isServer ? 'https://solaris-api.hu-staging.be/' : '/solaris-api/',
    SOLARIS_API_PUBLIC_PATH: isServer ? 'https://solaris-api.hu-staging.be/' : '/solaris-api/',
    DISCOVER_API_PATH: 'https://discover-api.hu-staging.be/',
    DISCOVER_API_KEY: 'API-KEY rXruMkVWQeXy7Bc9zgZjQN?WztRkDczA',
    WS_URL: 'wss://hu-staging.be/',
    IMG_PATH: 'https://d18gkrbst41gma.cloudfront.net',
    CDN_PATH: 'https://dw5al54dyefdn.cloudfront.net',
    ASSET_PREFIX_PATH: '',
    environment: 'development',
    gaTrackingId: '',
    gaTrackingDomain: '',
    allowBranchTesting: true,
  },
  'development-staging': {
    USE_DEV_PROXY: true,
    API_PATH: isServer ? 'https://hu-staging.be/api/' : '/api/',
    SOLARIS_API_PATH: isServer ? 'https://solaris-api.hu-staging.be/' : '/solaris-api/',
    SOLARIS_API_PUBLIC_PATH: isServer ? 'https://solaris-api.hu-staging.be/' : '/solaris-api/',
    DISCOVER_API_PATH: 'https://discover-api.hu-staging.be/',
    DISCOVER_API_KEY: 'API-KEY rXruMkVWQeXy7Bc9zgZjQN?WztRkDczA',
    WS_URL: 'wss://hu-staging.be/',
    IMG_PATH: 'https://d18gkrbst41gma.cloudfront.net',
    CDN_PATH: 'https://dw5al54dyefdn.cloudfront.net',
    ASSET_PREFIX_PATH: '',
    environment: 'development',
    gaTrackingId: '',
    gaTrackingDomain: '',
    allowBranchTesting: true,
  },
  'development-production': {
    USE_DEV_PROXY: true,
    API_PATH: isServer ? 'https://healthunlocked.com/api/' : '/api/',
    SOLARIS_API_PATH: isServer ? 'https://solaris.healthunlocked.com/' : '/solaris-api/',
    SOLARIS_API_PUBLIC_PATH: isServer ? 'https://solaris.healthunlocked.com/' : '/solaris-api/',
    DISCOVER_API_PATH: 'https://discover-api.healthunlocked.com/',
    DISCOVER_API_KEY: 'API-KEY YJfcggN6sn-gPuqkD_Gekya9KDud7FfR',
    WS_URL: 'wss://healthunlocked.com/',
    IMG_PATH: 'https://d1ngqubzx882dn.cloudfront.net',
    CDN_PATH: 'https://d3pv2lg0hr7u1j.cloudfront.net',
    ASSET_PREFIX_PATH: '',
    environment: 'development',
    gaTrackingId: '',
    gaTrackingDomain: '',
    allowBranchTesting: true,
  },
  'development-production-nice': {
    isNice: true, // Will disable various features, e.g. DFP, cookie banner, blocking signup modal
    USE_DEV_PROXY: true,
    API_PATH: isServer ? 'https://healthunlocked.com/api/' : '/api/',
    SOLARIS_API_PATH: isServer ? 'https://solaris.healthunlocked.com/' : '/solaris-api/',
    SOLARIS_API_PUBLIC_PATH: isServer ? 'https://solaris.healthunlocked.com/' : '/solaris-api/',
    DISCOVER_API_PATH: 'https://discover-api.healthunlocked.com/',
    DISCOVER_API_KEY: 'API-KEY YJfcggN6sn-gPuqkD_Gekya9KDud7FfR',
    WS_URL: 'wss://healthunlocked.com/',
    IMG_PATH: 'https://d1ngqubzx882dn.cloudfront.net',
    CDN_PATH: 'https://d3pv2lg0hr7u1j.cloudfront.net',
    ASSET_PREFIX_PATH: '',
    environment: 'development',
    gaTrackingId: '',
    gaTrackingDomain: '',
    allowBranchTesting: true,
  },
  staging: {
    API_PATH: 'https://hu-staging.be/api/',
    SOLARIS_API_PATH: 'https://hu-staging.be/',
    SOLARIS_API_PUBLIC_PATH: 'https://solaris-api.hu-staging.be/',
    DISCOVER_API_PATH: 'https://discover-api.hu-staging.be/',
    DISCOVER_API_KEY: 'API-KEY rXruMkVWQeXy7Bc9zgZjQN?WztRkDczA',
    WS_URL: 'wss://hu-staging.be/',
    IMG_PATH: 'https://d18gkrbst41gma.cloudfront.net',
    CDN_PATH: 'https://dw5al54dyefdn.cloudfront.net',
    ASSET_PREFIX_PATH: 'https://dw5al54dyefdn.cloudfront.net/solaris',
    environment: 'staging',
    gaTrackingId: 'UA-11066411-23',
    gaTrackingDomain: 'hu-staging.be',
    allowBranchTesting: true,
  },
  production: {
    API_PATH: 'https://healthunlocked.com/api/',
    SOLARIS_API_PATH: 'https://healthunlocked.com/',
    SOLARIS_API_PUBLIC_PATH: 'https://solaris.healthunlocked.com/',
    DISCOVER_API_PATH: 'https://discover-api.healthunlocked.com/',
    DISCOVER_API_KEY: 'API-KEY YJfcggN6sn-gPuqkD_Gekya9KDud7FfR',
    WS_URL: 'wss://healthunlocked.com/',
    IMG_PATH: 'https://d1ngqubzx882dn.cloudfront.net',
    CDN_PATH: 'https://d3pv2lg0hr7u1j.cloudfront.net',
    ASSET_PREFIX_PATH: 'https://d3pv2lg0hr7u1j.cloudfront.net/solaris',
    environment: 'production',
    gaTrackingId: 'UA-11066411-1',
    gaTrackingDomain: 'healthunlocked.com',
    allowBranchTesting: false,
  },
};



// WEBPACK FOOTER //
// ./config/environment.js